import { LegalShell, Section } from "@/components/LegalShell";

export default function Terms() {
  return (
    <LegalShell title="Terms of Service" subtitle="Legal" updated="February 2026">
      <Section title="1. Who we are">
        <p>SiteCrews (&ldquo;we&rdquo;, &ldquo;us&rdquo;) operates a labour marketplace connecting Irish contractors with tradespeople. By using SiteCrews you agree to these Terms. For questions email <a className="text-amber-500 hover:underline" href="mailto:hello@sitecrews.net">hello@sitecrews.net</a>.</p>
      </Section>
      <Section title="2. Your account">
        <p>You must be at least 18 and legally entitled to work in Ireland. You are responsible for keeping your login credentials safe and for everything that happens on your account.</p>
      </Section>
      <Section title="3. Nature of the service">
        <p>SiteCrews is a directory that lets employers post jobs and workers post their availability. We are <b>not</b> an employer, employment agency, or party to any contract of engagement between users. All hire, pay, tax, insurance and health &amp; safety obligations rest with the users themselves.</p>
      </Section>
      <Section title="4. Acceptable use">
        <ul className="list-disc pl-6 space-y-1">
          <li>Post accurate information about jobs, trades and availability</li>
          <li>Do not post discriminatory, illegal or unsafe listings</li>
          <li>Do not scrape, resell or misuse contact details revealed on the platform</li>
          <li>Do not attempt to bypass paid features (e.g. boost)</li>
        </ul>
      </Section>
      <Section title="5. Paid features">
        <p>Paid features such as Boost Job are one-off charges billed through Stripe. Prices are shown in EUR and may be subject to Irish VAT. Purchases are non-refundable once a boost is live except where required by law.</p>
      </Section>
      <Section title="6. Liability">
        <p>SiteCrews is provided on an &ldquo;as is&rdquo; basis. To the maximum extent permitted by law we exclude liability for indirect or consequential loss, including lost profits, arising from your use of the platform or any engagement resulting from it.</p>
      </Section>
      <Section title="7. Termination">
        <p>We may suspend or terminate accounts that breach these Terms or applicable law. You can close your account at any time by contacting us.</p>
      </Section>
      <Section title="8. Governing law">
        <p>These Terms are governed by the laws of Ireland. Any dispute is subject to the exclusive jurisdiction of the Irish courts.</p>
      </Section>
    </LegalShell>
  );
}
